import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import downarrow from "../../assets/downarrow.png";
import email from "../../assets/email.png";
import uparrow from "../../assets/uparrow.png";
import ActivateCard from "../../Components/Cards/ActivateCard/ActivateCard";
import DeleteCard from "../../Components/Cards/DeleteCard/DeleteCard";
import Mail from "../../Components/Cards/Mail/Mail";
import Application_Form from "../../Components/Forms/Application/Application_Form";
import { useSearch } from "../../context/SearchContext";
import { storage } from "../../firebase";
import api from "../../utils/api";
import "./Application.css";
import Application_type_list from "./ApplicationTypeList";
import cancel from "../../assets/cancel.png";


const Application = (props) => {
  const { search } = useSearch();
  const [data, setData] = useState([]);  
  const [startDate, setStartDate] = useState("");
  const [status, setStatus] = useState(false);
  const [id, setId] = useState(null); // Initialize as null
  const [open, setOpen] = useState("");
  const [msgDisplay, setMsgDisplay] = useState(0);
  const [selectedMsg, setSelectedMsg] = useState("");
  const [del, setDel] = useState(0);
  const [delId, setDelId] = useState(0);
  const [sortBy, setSortBy] = useState("asc");
  const [display1, setDisplay1] = useState(0);
  const [display2, setDisplay2] = useState(0);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  });
  const [file, setFile] = useState(null); // Initialize as null
  const [isDragging, setIsDragging] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validationError, setValidationError] = useState(""); // New state for validation error
  const handleUpload = (e) => {
    setFile(e.target.files[0]);
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    if (selectedFile) {
      setValidationError("");
    }
  };

  const handleDragOver = useCallback((e) => {
    e.preventDefault();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback((e) => {
    e.preventDefault();
    setIsDragging(false);
  }, []);

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    setIsDragging(false);
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile) {
      setFile(droppedFile);
    }
  }, []);

  const fetchData = useCallback(async () => {
    await api
      .get(
        `/applications?search=${search}&page=${pagination.page}&limit=${pagination.limit}`
      )
      .then((response) => response.data)
      .then((data) => {
        setData(data.data);
        setPagination(data.pagination);
      });
  }, [search, pagination.page, pagination.limit]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleFilter = async () => {
    await api
      .get(`/applications/?dt=${startDate}`)
      .then((response) => response.data)
      .then((data) => {
        setData(data.data);
      });
  };

  const handleStatus = async () => {
    await api.put(`/applications/${id}`, {
      status: "completed",
    });
    toast.success("Application updated successfully");
    fetchData();
    setStatus(false);
  };

  const handleDeleteApplication = async (id) => {
    try {
      const response = await api.delete(`/applications/${id}`);
      if (response.status !== 200) {
        throw new Error("Error while deleting");
      } else {
        await api
          .get(`/applications`)
          .then((response) => response.data)
          .then((data) => {            
            toast.success("Application deleted successfully");
            setDel(0);
            setDelId(0);
            setData(data.data);
          });
      }
    } catch (err) {
      console.log(err);
      toast.error("Error while deleting application");
    }
  };

  const sortedData = React.useMemo(() => {
    if (!Array.isArray(data)) return [];
    const sorted = [...data];
    sorted.sort((a, b) => {
      const dateA = new Date(a.requested);
      const dateB = new Date(b.requested);
      return sortBy === "asc" ? dateA - dateB : dateB - dateA;
    });
    return sorted;
  }, [data, sortBy]);

  const handleClick = () => {
    setDisplay1(1);
  };

  const handleClickViewApplicationType = () => {
    setDisplay2(1);
  };

  const handleFormClose = () => {
    setDisplay1(0);
    fetchData();
  };

  const handleTypeListClose = () => {
    setDisplay2(0);
    fetchData();
  };

  const handlePageChange = (newPage) => {
    setPagination((prev) => ({
      ...prev,
      page: newPage,
    }));
  };

  return (
    <div className="application">
      {del ? (
        <DeleteCard
          del={() => {
            handleDeleteApplication(delId);
          }}
          close={() => {
            setDel(0);
          }}
        />
      ) : null}
      {display2 ? (
        <Application_type_list setDisp={handleTypeListClose} />
      ) : null}
      {display1 ? <Application_Form setDisp={handleFormClose} /> : null}
      {status ? (
        <ActivateCard
          action={() => {
            handleStatus();
          }}
          close={() => {
            setStatus(false);
          }}
        />
      ) : null}
      <div className="application__top">
        <div
          className="application__top_button"
          style={{ display: "contents" }}
        >
          <div className="filter-container">
            <div className="datepicker-container">
              <input
                type="date"
                name=""
                className="datepicker"
                value={startDate}
                onChange={(e) => {
                  setStartDate(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
        <div className="application__top_button" style={{ display: "flex" }}>
          <button
            type="button"
            className="application__top_button_go"
            onClick={handleFilter}
          >
            Go
          </button>
          <button
            type="button"
            className="circular__top_button_go"
            onClick={async () => {
              setStartDate("");
              await api
                .get(`/applications`)
                .then((response) => response.data)
                .then((data) => {
                  setData(data.data);
                });
            }}
          >
            Clear
          </button>
        </div>

        <div style={{ width: "100%", display: "flex" }}>
          <button
            style={{
              marginLeft: "auto",
              padding: "0 5px",
            }}
            type="button"
            className="application_type_add_button"
            onClick={handleClickViewApplicationType}
          >
            Application type List
          </button>
          <button
            type="button"
            className="application_type_add_button"
            onClick={handleClick}
          >
            Add application type
          </button>
        </div>
      </div>

      <div className="application__middle">
        <table>
          <thead>
            <tr className="application__middle_tr">
              <th className="application__middle_th">GR Number</th>
              <th className="application__middle_th">Name</th>
              <th className="application__middle_th">Class</th>
              <th className="application__middle_th">Form</th>
              <th className="application__middle_th">Section</th>
              <th className="application__middle_th">Application Type</th>
              <th className="application__middle_th">
                Request Date{" "}
                {sortBy === "asc" ? (
                  <img
                    src={uparrow}
                    alt="uparrow"
                    style={{
                      height: 20,
                      width: 20,
                      marginBottom: -5,
                      marginLeft: 10,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setSortBy("desc");
                    }}
                  />
                ) : (
                  <img
                    src={downarrow}
                    alt="downarrow"
                    style={{
                      height: 20,
                      width: 20,
                      marginBottom: -5,
                      marginLeft: 10,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setSortBy("asc");
                    }}
                  />
                )}
              </th>
              <th className="application__middle_th">Amount</th>
              <th className="application__middle_th">Payment Status</th>
              <th className="application__middle_th">Contact</th>
              <th className="application__middle_th">Status</th>
              <th className="application__middle_th">File</th>
              <th className="application__middle_th">Payment Receipt</th>
              <th className="application__middle_th"></th>
            </tr>
          </thead>
          <tbody>
            {sortedData && sortedData.length > 0 ? (
              sortedData.map((row) => (
                <tr className="application__middle_tr" key={row.id}>
                  <td className="application__middle_td">{row.gr || "-"}</td>
                  <td className="application__middle_td">{row.name || "-"}</td>
                  <td className="application__middle_td">{row.class || "-"}</td>
                  <td className="application__middle_td">
                    {row.msg ? (
                      <button
                        type="button"
                        onClick={() => {
                          setId(row.id);
                          setMsgDisplay(1);
                          setSelectedMsg(row.msg);
                        }}
                        className="application__top_button_go"
                      >
                        View
                      </button>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td className="application__middle_td">
                    {row.section || "-"}
                  </td>
                  <td className="application__middle_th">
                    {row.application_type || "-"}
                  </td>
                  <td className="application__middle_td">
                    {row.requested
                      ? moment(row.requested).format("DD-MM-YYYY")
                      : "-"}
                  </td>
                  <td className="application__middle_td">{row.amount ?? 50}</td>
                  <td className="application__middle_td">
                    {row.payment_status}
                  </td>
                  <td className="application__middle_td">
                    {row.contact ? (
                      <button
                        type="button"
                        onClick={() => {
                          setOpen(row.id);
                        }}
                        style={{
                          border: "none",
                          backgroundColor: "transparent",
                        }}
                      >
                        <img src={email} alt="email" />
                      </button>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td className="application__middle_td">
                    <div>
                      <button
                        type="button"
                        className={`application__middle_td_status ${
                          row.status === "pending" ? "pending" : "proceed"
                        }`}
                        onClick={() => {
                          setId(row.id);
                          setStatus(true);
                        }}
                      >
                        {row.status === "pending" ? "Pending" : "Completed"}
                      </button>
                    </div>
                  </td>
                  <td className="application__middle_td">
                    {row.fileUrl || row.attachment ? (
                      <a
                        href={row.fileUrl || row.attachment}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "underline" ,color: "green",cursor: "pointer" }}
                      >
                        View 
                      </a>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td className="application__middle_td">
                    {row.payment_receipt ? (
                      <a
                        href={row.payment_receipt}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "underline" ,color: "green",cursor: "pointer" }}
                      >
                        View 
                      </a>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td className="application__middle_td">
                    <button
                      type="button"
                      className="setup__middle_td_delete"
                      onClick={() => {
                        setDel(1);
                        setDelId(row.id);
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="application__middle_tr">
                <td colSpan={11}>
                  <p style={{ padding: "30px", textAlign: "center" }}>
                    No Data Found
                  </p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {msgDisplay === 1 && (
        <div className="msg-modal-overlay">
          <div className="msg-modal">
            <button
              className="msg-modal-close"
              onClick={() => {
                setMsgDisplay(0);
                setFile(null);
                setId(null);
                setSelectedMsg("");
              }}
              style={{
                position: "absolute",
                top: 10,
                right: 10,
                background: "transparent",
                border: "none",
                fontSize: "20px",
                cursor: "pointer",
              }}
            >
            <img src={cancel} alt="cancel" />
              
            </button>
            <div style={{ padding: "20px" }}>
              <h3>Form</h3>
              {(() => {
                try {
                  const parsedMsg = JSON.parse(selectedMsg);
                  if (typeof parsedMsg === "object") {
                    return Object.keys(parsedMsg).map((item) => (
                      <div key={item} style={{ marginTop: "10px" }}>
                        {item} :- {parsedMsg[item]}
                      </div>
                    ));
                  }
                } catch (e) {
                  return (
                    <div style={{ marginTop: "10px", whiteSpace: "pre-wrap" }}>
                      {selectedMsg}
                    </div>
                  );
                }
              })()}

              <div
                className={`drop-zone ${isDragging ? "dragging" : ""}`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                style={{
                  marginTop: "20px",
                  padding: "30px",
                  border: "2px dashed #aaa",
                  borderRadius: "6px",
                  textAlign: "center",
                }}
              >
                <input
                  type="file"
                  name="file"
                  onChange={handleUpload}
                  id="file-input"
                  className="file-input"
                  style={{ display: "none" }}
                />
                <label
                  htmlFor="file-input"
                  className="file-label"
                  style={{ cursor: "pointer" }}
                >
                  {file ? (
                    <div className="file-info">
                      <span className="file-name">{file.name}</span>
                      <span className="file-size">
                        ({(file.size / 1024).toFixed(2)} KB)
                      </span>
                    </div>
                  ) : (
                    <div className="upload-placeholder">
                      <p>📁 Drag & drop your file here or click to browse</p>
                    </div>
                  )}
                </label>
              </div>

              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                }}
              >
                {/* Display validation error if it exists */}
                {validationError && (
                  <div
                    style={{
                      color: "red",
                      marginRight: "70px",
                      marginBottom: "10px",
                    }}
                  >
                    {validationError}
                  </div>
                )}
                <button
                  onClick={async () => {
                    if (!file) {
                      // toast.error("Please select a file first.");
                      setValidationError("Please select a file first."); // Set validation error instead of toast
                      return;
                    }
                    if (!id) {
                      toast.error("No application selected. Please try again.");
                      return;
                    }
                    setLoading(true);
                    try {
                      const storageRef = ref(
                        storage,
                        `messages/${id}/${file.name}`
                      );
                      await uploadBytes(storageRef, file);
                      const url = await getDownloadURL(storageRef);
                      await api.put(`/applications/response/${id}`, {
                        fileUrl: url,
                      });
                      toast.success("File uploaded successfully!");
                      setMsgDisplay(0);
                      setFile(null);
                      setId(null);
                      setSelectedMsg("");
                      await fetchData();
                    } catch (err) {
                      console.error(
                        "Upload error:",
                        err.response?.data || err.message
                      );
                      toast.error("File upload failed.");
                    } finally {
                      setLoading(false);
                    }
                  }}
                  style={{
                    padding: "8px 16px",
                    backgroundColor: "#1eae7a",
                    color: "white",
                    border: "none",
                    borderRadius: "16px",
                    cursor: "pointer",
                  }}
                >
                  {loading ? (
                    <span>
                      <span className="loader-spinner"></span>
                      Uploading...
                    </span>
                  ) : (
                    "Save"
                  )}
                </button>
                <button
                  onClick={() => {
                    setMsgDisplay(0);
                    setFile(null);
                    setId(null);
                    setSelectedMsg("");
                  }}
                  style={{
                    padding: "8px 16px",
                    backgroundColor: "#cb444a",
                    color: "white",
                    border: "none",
                    borderRadius: "16px",
                    cursor: "pointer",
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {open !== "" ? (
        <Mail open={open} app={true} close={() => setOpen("")} />
      ) : null}

      <div
        className="pagination-controls"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginTop: "20px",
          gap: "10px",
        }}
      >
        <button
          onClick={() => handlePageChange(pagination.page - 1)}
          disabled={pagination.page === 1}
          style={{
            padding: "5px 10px",
            cursor: pagination.page === 1 ? "not-allowed" : "pointer",
            opacity: pagination.page === 1 ? 0.5 : 1,
          }}
        >
          Previous
        </button>

        <span>
          Page {pagination.page} of {pagination.totalPages}
        </span>

        <button
          onClick={() => handlePageChange(pagination.page + 1)}
          disabled={pagination.page === pagination.totalPages}
          style={{
            padding: "5px 10px",
            cursor:
              pagination.page === pagination.totalPages
                ? "not-allowed"
                : "pointer",
            opacity: pagination.page === pagination.totalPages ? 0.5 : 1,
          }}
        >
          Next
        </button>

        <div style={{ marginLeft: "20px" }}>
          <label htmlFor="limit-select" style={{ marginRight: "10px" }}>
            Items per page:
          </label>
          <select
            id="limit-select"
            value={pagination.limit}
            onChange={(e) => {
              setPagination((prev) => ({
                ...prev,
                limit: Number(e.target.value),
                page: 1,
              }));
            }}
            style={{
              padding: "5px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              backgroundColor:"rgb(239,239,239)",

            }}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default Application;
